const config = require('../../../content/meta/config')

import React from 'react'

// Import typefaces
import 'typeface-montserrat'
//import 'typeface-merriweather'

//import profilePic from './profile-pic.jpg'
import profilePic from './0.jpeg'
import { rhythm } from '../../utils/typography'

const Bio = props => {
  const articleCount = props.articleCount;
  let aa = ""
  const isLast = props.isLast ? props.isLast : false
  if (isLast) {
    aa = (<p> Click <a href="/blog"> here </a> to go back.</p>);
  }
  return (
    <div
      style={{
        display: 'flex',
        //marginBottom: rhythm(2.5),
        marginBottom: rhythm(1),
      }}
    >
      <img
        src={profilePic}
        alt={config.authorName}
        style={{
          marginRight: rhythm(1 / 2),
          marginBottom: 0,
          width: rhythm(2),
          height: rhythm(2),
        }}
      />
      <div>
        This is the personal blog  of <strong>{config.authorName}</strong> and has {articleCount}. {aa}
      </div>

      {/* who lives and works in San
          Francisco building useful things.{' '}
          <a href="https://twitter.com/kylemathews">
            You should follow him on Twitter
          </a> */}
    </div>
  )
}


export default Bio



// WEBPACK FOOTER //
// ./src/components/Bio/Bio.js